export default __webpack_public_path__ + "static/media/how-to-use-hero.77d0ac52.webp";